import React from 'react';
import View from '../../table/view'
import { createSite, deleteSite, getSites, updateSite } from '../../slices/sites'
import { useSelector } from 'react-redux';
import { renderListCell, ListCellSelector } from '../../table/list-cell';

const Site = ({ notifySelection }) => {
  const selector = (state) => state.customers.items
  const customers = useSelector(selector)
  const columnDefs = [
    { field: 'id', headerName: 'Id', sortable: true, minWidth: 80, checkboxSelection: true },
    { field: 'name', editable: true, formEnabled: true, headerName: 'Name', editable: true,sortable: true, minWidth: 80 },
    { field: 'address1', editable: true, formEnabled: true, headerName: 'Address 1', sortable: true, minWidth: 80 },
    { field: 'address2', editable: true, formEnabled: true, headerName: 'Address 2', sortable: true, minWidth: 80 },
    { field: 'owner', editable: false, formEnabled: false, headerName: 'Owner', sortable: true, minWidth: 80 },
    {
      field: 'siteCustomerId',
      headerName: 'Customer',
      formEnabled: true,
      type: "singleselect",
      sortable: true,
      editable: true,
      minWidth: 80,
      valueOptions: customers.map((item) => item.name),
      valueLookup: customers.map((item) => item.id),
      renderEditCell: (params) => <ListCellSelector {...params} selectorCallback={selector} />,
      renderCell: (params) => renderListCell(params, selector)
    },
    { field: 'createdAt', headerName: 'Created At', sortable: true, minWidth: 210 },
    { field: 'updatedAt', headerName: 'Updated At', sortable: true, minWidth: 100 },
    { field: 'active', headerName: 'Active', type: 'boolean', sortable: true, minWidth: 100 },
  ];
  const user_groups = useSelector((state) => state.currentUser.groups);
  const isAdmin = user_groups.includes('admin');
  if (isAdmin) {
    columnDefs.push(
      { field: 'deleted', headerName: 'Deleted', formEnabled: true, sortable: true, minWidth: 100, type: 'boolean' },
    )
  }
  return (
    <View
      name="Site"
      columnDefs={columnDefs}
      deleteFunction={deleteSite}
      getFunction={getSites}
      updateFunction={updateSite}
      createFunction={createSite}
      stateSelector={(state) => state.sites}
      addEnabled={true}
      deleteEnabled={true}
      notifySelection={(event) => {
        notifySelection(event);
      }}
    />
  )
}

export default Site;
